import { PhotoModel } from '@/helpers/entities/models/PhotoModel';
export class FaqInputModel {
    constructor(payload) {
        const { uuid, active, question, answer, images } = payload;
        this.uuid = uuid;
        this.question = question;
        this.answer = answer;
        this.active = active;
        this.images = images.map((image) => new PhotoModel(image));
    }
}
